import React from "react";
import { ContactSupportModal } from "../../modals";
import { Button } from "../../common/Button";

export const AccountRemovalForm: React.FC = () => {
  return (
    <div>
      <div className="pt-9 pb-6 uppercase text-sm font-manrope font-semibold text-gray-300 tracking-[1px] border-b border-gray-50">
        Account removal
      </div>

      <div className="py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-base max-w-[285px] text-gray-300">
            Please contact our customer support team to delete account forever
          </div>

          <ContactSupportModal
            title="Please contact our support service"
            subtitle="Right now we can only remove your account via our support service. Once your account is deleted, all your invoices, clients, profile and wallets will be permanently deleted."
          >
            {(action) => (
              <Button variant={Button.variant.CRITICAL} onClick={action}>
                Contact support
              </Button>
            )}
          </ContactSupportModal>
        </div>
      </div>
    </div>
  );
};
